import React, { useEffect } from "react";
import Slider from "react-slick";
import "./Home.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowUp } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";
import { toast } from "react-toastify";

const Home = () => {


    const scrollToTop = () => {
      scroll.scrollToTop();
    };

  useEffect(() => {
    if (localStorage.getItem("loginSuccess")) {
      toast.success("Login Successful!");
    }
    setTimeout(() => {
      localStorage.removeItem("loginSuccess");
    }, 3000);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
    ]
  };

  return (
    <>
      <div className="Home" id="homepage">
          <div className="carousel-container">
            <Slider {...settings}>
              <div><img src="/s1.png" alt="pic1" /></div>
              <div><img src="/s2.png" alt="pic2" /></div>
              <div><img src="/s3.png" alt="pic3" /></div>
            </Slider>
          </div>
        </div>
      <div className="scroll-top" onClick={scrollToTop}>
        <FaArrowUp size={20} style={{ color: "white" }} />
        </div>
    </>
  );
};

export default Home;
